import ImagePageWrapper from "components/pages/ImagePageWrapper";
import { TemplateDocumentsList } from "features/TemplateDocumentsList";
import React from "react";

const TemplateDocumentsPage = () => {
  return (
    <ImagePageWrapper title="Template Documents">
      <TemplateDocumentsList />
    </ImagePageWrapper>
  );
};

export default TemplateDocumentsPage;
